<template>
  <div>
    <b-dropdown position="is-bottom-left">
      <button class="button" slot="trigger">
        <b-icon icon="dots-horizontal"></b-icon>
      </button>
      <b-dropdown-item
        @click="createMagazine()">
        <span>Add new magazine</span>
      </b-dropdown-item>
    </b-dropdown>

    <b-modal :active.sync="createCouponMagazine" :width="640" scroll="keep">
      <div class="card">
        <div class="card-content">
          <form @submit.prevent="handleSubmitCreate()">
            <div class="columns">
              <div class="column is-6">
                <b-field label="Magazine">
                  <magazine-selector v-model="newForm.magazine_id"></magazine-selector>
                </b-field>
              </div><!-- 
              <div class="column is-6">
                <b-field label="Magazine plan" v-if="newForm.magazine_id">
                  <b-select placeholder="Select a name">
                    <option
                      v-for="option in data"
                      :value="option.id"
                      :key="option.id">
                      {{ option.user.first_name }}
                    </option>
                  </b-select>
                </b-field>
              </div> -->
              <hr/>
            </div>
            <hr>
            <div class="is-pulled-right">
              <b-button type="button" @click="createCouponMagazine = false">Cancel</b-button>
              <button class="button is-primary">
                <b-icon icon="content-save"></b-icon>
                <span>save</span>
              </button>
            </div>

          </form>
          <br>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import MagazineSelector from "./selectors/MagazineSelector";

export default {
  components: {
    MagazineSelector
  },

  data() {
    return {
      newForm: new window.Form({
        coupon_id: this.$route.params.id,
        magazine_id: null,
        plan_id: null
      }),
      createCouponMagazine: false
    };
  },

  props: {
    whenUpdated: {
      type: Function,
      default: () => () => {}
    }
  },

  methods: {
    createMagazine() {
      this.newForm.coupon_id = this.$route.params.id;
      this.createCouponMagazine = true;
      this.reload();
    }
  }
};
</script>